import { FuelButton } from '@frete.com/fuel-react'
import { useEffect, useRef } from 'react'
import BaseModal from '~components/BaseModal'
import { Props } from './interfaces'
import * as Styled from './styled'
import { useNavigate } from 'react-router-dom'

function ModalAside({ open, children, title, portalName, closeIcon, onClose, ...rest }: Props) {
  const baseRef = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)
  const navigate = useNavigate()

  function stopPropagation(event: React.MouseEvent<HTMLDivElement>) {
    event.stopPropagation()
  }

  const handleClose = () => {
    contentRef.current.classList.remove('animated')
    setTimeout(() => {
      onClose?.(navigate)
    }, 200)
  }

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        contentRef.current?.classList.add('animated')
      }, 100)
    }
  }, [open])

  return (
    <BaseModal open={open} innerRef={baseRef} portalName={portalName} {...rest}>
      <Styled.Container $open={open} onClick={handleClose} role="dialog">
        <Styled.ModalAside ref={contentRef} onClick={stopPropagation}>
          <Styled.ActionSection>
            <FuelButton onlyIcon leadingIcon={closeIcon} aria-label="back" onClick={handleClose} variant="subtle" />
          </Styled.ActionSection>
          <Styled.Title>{title}</Styled.Title>
          {children}
        </Styled.ModalAside>
      </Styled.Container>
    </BaseModal>
  )
}

ModalAside.defaultProps = {
  closeIcon: 'arrow-left',
}

export default ModalAside
